export default "__VITE_ASSET__07d64eae__"